export const getChoosenWidgets = ({
  selectedWidgets,
  selectedWidgetsCOO,
  selectedWidgetsCOOSupply,
  selectedWidgetsMarket,
  selectedAdWidgets,
  showOnly,
}) => {
  switch (showOnly) {
    case "CFO":
      return selectedWidgetsCOOSupply;
    case "COO":
      return selectedWidgetsCOO;
    case "Market":
      return selectedWidgetsMarket;
    case "Ad":
      return selectedAdWidgets;
    default:
      return selectedWidgets;
  }
};
